module.exports = __webpack_public_path__ + "img/BTN.0e172ea9.gif";